.notFoundContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  .notFoundWrapper {
    display: flex;
    max-width: 600px;
    gap: var(--fly-number-spacing-6);
    .notFoundTextWrapper {
      max-width: 100%;
      overflow: hidden;
      flex: 1;
    }
    .notFoundText {
      font-size: var(--fly-typography-size-6);
      div {
        padding-top: var(--fly-number-spacing-5);
        padding-bottom: var(--fly-number-spacing-5);
      }
    }
    svg {
      opacity: 0.6;
    }
  }
}
